/**
 * Formats phone number: 1234567890 => (123) 456-7890
 * Removes all non-digits
 * If there are more than 10 digits, this will also render an extension
 * that includes the remainder of the string
 * IE: 12345678901234 => (123) 456-7890 ext. 1234
 * @param phone number to format
 * @return formatted phone number
 */
export default function formatPhoneNumber(phone: string | null) {
  if (!phone) {
    return '';
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_function_as_a_parameter
  const replacer = (_match, p1, p2, p3, p4) => {
    const ext = p4 ? ` ext. ${p4}` : '';

    return `(${p1}) ${p2}-${p3}${ext}`;
  };

  return String(phone)
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})(\d*)/, replacer);
}
